export var PolygonTestnet = {
    chainId: "0x13881",
    chainName: "Polygon Testnet",
    rpcUrls: ["https://matic-mumbai.chainstacklabs.com"],
    nativeCurrency: {
        name: "Polygon",
        symbol: "MATIC",
        decimals: 18,
    },
    blockExplorerUrls: ["https://mumbai.polygonscan.com/"],
};
export var PolygonMainnet = {
    chainId: "0x89",
    chainName: "Polygon",
    rpcUrls: ["https://rpc-mainnet.matic.network"],
    nativeCurrency: {
        name: "Polygon",
        symbol: "MATIC",
        decimals: 18,
    },
    blockExplorerUrls: ["https://polygonscan.com/"],
};
